import React, { ReactElement } from 'react';
import MFEContainer from './../MFEContainer';
import { useSession } from '../../hooks/redux';
import { RouteComponentProps } from 'react-router-dom';

interface IReportLibraryProps extends RouteComponentProps {
  enabled?: boolean;
}

function ReportLibrary({ enabled, history }: IReportLibraryProps): ReactElement {
  const session = useSession();
  if (enabled === false) history.push('/');

  const sessionData = {
    csrfTimestamp: session.csrfPair.csrf_timestamp,
    csrfToken: session.csrfPair.csrf_token,
    group: {
      id: session.group.id,
      default: session.organization.defaultGroup.id
    },
    organization: {
      id: session.organization.id
    },
    replacementTokens: session.replacementTokens,
    reportViewerRights: {
      allowViewGroup: session.reportViewerRights.allowViewGroup,
      allowViewSite: session.reportViewerRights.allowViewGroup,
      allowViewStandard: session.reportViewerRights.allowViewGroup
    },
    sameOrgAndGroup: session.group.id === session.organization.defaultGroup.id,
    subsite: session.organization.code,
    user: {
      email: session.user.email,
      id: session.user.id,
      isGroupAdmin: session.user.rights.groupAdmin,
      isReportViewer: session.user.rights.reportViewUser,
      isSiteAdmin: session.user.rights.siteAdmin,
      isSuperAdmin: session.user.rights.superAdmin
    }
  };

  return (
    <MFEContainer
      name="@mfe/ReportLibrary"
      mfeAttributes={{
        'group-functionality': !sessionData.sameOrgAndGroup,
        platform: 'marketpay',
        'use-collections': true,
        'report-url': `/view/o/${sessionData.subsite}/mp/iframe/app/#reportWriter`
      }}
      mfeProperties={{
        session: sessionData
      }}
    />
  );
}

export default ReportLibrary;
